import { useEffect, useState } from 'react';

import { getNestedObjectFieldsSum } from './helpers';

export const useCalculateTotal = (toCalculateFields: object, omittedFields: string[]) => {
  const [total, setTotal] = useState(0);

  useEffect(() => {
    const sum = Number((getNestedObjectFieldsSum(toCalculateFields, omittedFields)).toFixed(2));

    setTotal(sum);
  }, [toCalculateFields, omittedFields]);
  return total;
};
